import clsx from 'clsx';
import type { Icon } from 'react-bootstrap-icons';
import { useLocation } from 'react-router-dom';

import { SDSIcon } from '@repo/sds/SDSIcon';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';

import './SettingsPanelItem.scss';

export interface SettingsPanelItemProps {
  icon: Icon;
  title: string;
  path: string;
  disabled?: boolean;
  testid?: string;
  variant?: 'sidebar' | 'dropdown';
  onNavigate?: () => void;
}

export function SettingsPanelItem({
  icon: IconComponent,
  title,
  path,
  disabled = false,
  testid,
  variant = 'sidebar',
  onNavigate,
}: SettingsPanelItemProps) {
  const location = useLocation();
  const isSelected = location.pathname.startsWith(path);

  const rootClassName = clsx('SettingsPanelItem', {
    'SettingsPanelItem--selected': isSelected,
    'SettingsPanelItem--disabled': disabled,
    'SettingsPanelItem--dropdown': variant === 'dropdown',
  });

  return (
    <SDSPrimitiveButton
      dataTestId={testid}
      className={rootClassName}
      href={path}
      onLinkClick={onNavigate}
      ariaCurrent={isSelected ? 'page' : undefined}
    >
      <SDSIcon className="SettingsPanelItem__icon" icon={<IconComponent />} />
      <SDSText
        text={title}
        className="SettingsPanelItem__text"
        type={isSelected ? 'body-large-bold' : 'body-large'}
        align={variant === 'dropdown' ? 'center' : 'left'}
        color="inherit"
      />
    </SDSPrimitiveButton>
  );
}
